import { render, staticRenderFns } from "./FrequencySettingsEditMobile.vue?vue&type=template&id=020bb843"
import script from "./FrequencySettingsEditMobile.vue?vue&type=script&lang=ts"
export * from "./FrequencySettingsEditMobile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('020bb843')) {
      api.createRecord('020bb843', component.options)
    } else {
      api.reload('020bb843', component.options)
    }
    module.hot.accept("./FrequencySettingsEditMobile.vue?vue&type=template&id=020bb843", function () {
      api.rerender('020bb843', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/frequency-documents/FrequencySettingsEditMobile.vue"
export default component.exports